import EmailIcon from '@mui/icons-material/Email'
import { IconButton, Link, Typography } from '@mui/material'

interface EmailAddressProps {
  email: string

}

const EmailAddress = ({ email }: EmailAddressProps) => {
  const emailLink = `mailto:${email}`

  return (
    <Typography>
        <IconButton style={{ paddingLeft: '0' }}>
          <EmailIcon fontSize="small" />
        </IconButton>
      <Link href={emailLink}>
        {email} 
      </Link>
    </Typography>
  )
}

export default EmailAddress